class DetectScroll {
    constructor(i) {
        this.element = i;
        this.deadZone = 10;
        this.isScrolling = false;
        if (this.element.dataset.detectScroll != '') {
            this.scrollingElement = this.element.querySelector(this.element.dataset.detectScroll);
        } else {
            this.scrollingElement = this.element;
        }
        this.bindEvents();
        this.calcPosition();
    }

    bindEvents() {

        const that = this;

        function scrollFunc() {
            if (that.isScrolling === false) {
                that.resetClasses();
            }
            handleScroll();
        }

        const handleScroll = debounce(() => this.debouncedFunc()).bind(this);

        this.scrollingElement.addEventListener('scroll', scrollFunc);
    }

    debouncedFunc() {
        this.calcPosition();
        this.isScrolling = false;
    }

    resetClasses() {
        this.element.classList.remove('scroll-top');
        this.element.classList.remove('scroll-right');
        this.element.classList.remove('scroll-bottom');
        this.element.classList.remove('scroll-left');
        this.element.classList.remove('scroll-v-mid');
        this.element.classList.remove('scroll-h-mid');
    }

    calcPosition() {

        this.resetClasses();

        if (this.scrollingElement.scrollHeight > this.scrollingElement.clientHeight) {

            if ((this.scrollingElement.offsetHeight + this.scrollingElement.scrollTop) > (this.scrollingElement.scrollHeight - this.deadZone)) {
                this.element.classList.add('scroll-bottom');
            } else if (this.scrollingElement.scrollTop < this.deadZone) {
                this.element.classList.add('scroll-top');
            } else {
                this.element.classList.add('scroll-v-mid');
            }
        }

        if (this.scrollingElement.scrollWidth > this.scrollingElement.clientWidth) {

            if ((this.scrollingElement.offsetWidth + this.scrollingElement.scrollLeft) > (this.scrollingElement.scrollWidth - this.deadZone)) {
                this.element.classList.add('scroll-right');
            } else if (this.scrollingElement.scrollLeft < this.deadZone) {
                this.element.classList.add('scroll-left');
            } else {
                this.element.classList.add('scroll-h-mid');
            }
        }

    }
}


document.querySelectorAll('[data-detect-scroll]').forEach(i => {
    let scroller = new DetectScroll(i);
});